// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"fb652c56","355":"0d607111","368":"c214934a","453":"98abf2ea","519":"b168ea91","658":"63a49705","843":"5083c2b1","863":"66e68291","874":"b56fc1cd"}[chunkId] + ".chunk.js";
};